import React, { useMemo, useState } from "react";
import { Container, TableWrapper } from "./ListStyles";
import { Pagination } from "./Pagination";
import { ListRenderer } from "./ListRenderer";

export const ServerPagedList = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  columns,
  renderProps,
  prefixHeader,
  prefixBodyBuilder,
  suffixHeader,
  suffixBodyBuilder,
  onRowClick,
}) => {
  const [sortKey, setSortKey] = useState(null);
  const [isAscending, setIsAscending] = useState(null);

  const hasPrefix = !!(prefixHeader || prefixBodyBuilder);
  const hasSuffix = !!(suffixHeader || suffixBodyBuilder);

  const sortedData = useMemo(() => {
    if (!sortKey || !data) return data;
    const col = columns?.find((c) => c.key === sortKey);
    if (!col?.compareBy) return data;
    return [...data].sort((a, b) => {
      const result = col.compareBy(a, b);
      return isAscending ? result : -result;
    });
  }, [data, sortKey, isAscending, columns]);

  const handleSort = (col) => {
    if (!col.compareBy) return;
    if (sortKey === col.key) {
      setIsAscending((prev) => !prev);
    } else {
      setSortKey(col.key);
      setIsAscending(true);
    }
  };

  return (
    <Container>
      <TableWrapper>
        <ListRenderer
          columns={columns}
          data={sortedData}
          renderProps={renderProps}
          hasPrefix={hasPrefix}
          hasSuffix={hasSuffix}
          prefixHeader={prefixHeader}
          prefixBodyBuilder={prefixBodyBuilder}
          suffixHeader={suffixHeader}
          suffixBodyBuilder={suffixBodyBuilder}
          onRowClick={onRowClick}
          sortKey={sortKey}
          isAscending={isAscending}
          onSort={handleSort}
        />
      </TableWrapper>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </Container>
  );
};
